import React from 'react'
import { NavLink } from 'react-router-dom'
import demoVideosButton from '../../../../app/helpers/demovideosbutton'
import { IconType } from 'react-icons'

interface Props {
  collapsed: boolean
}

const DemoVideosSidebarButton: React.FC<Props> = ({ collapsed }) => {
  const Icon = demoVideosButton.icon as IconType
  return (
    <div className="mt-auto px-2 mb-2" style={{marginTop: 'auto'}}>
      <NavLink to={demoVideosButton.to} className="text-decoration-none">
        <div
          className={`menu-item d-flex align-items-center gap-2 rounded p-3 transition-base bg-primary text-white shadow-sm ${collapsed ? 'justify-content-center' : ''}`}
        >
          <span className={`svg-icon-2 ${!collapsed ? 'me-2' : ''}`}>
            <Icon fontSize={22} color={'#fff'} />
          </span>
          {!collapsed && <span style={{ fontSize: '14px' }}>{demoVideosButton.title}</span>}
        </div>
      </NavLink>
    </div>
  )
}

export default DemoVideosSidebarButton
